import * as THREE from "three";

export interface SavedCameraPosition {
  isOrthograpic: boolean;
  position: THREE.Vector3;
  rotation: THREE.Quaternion;
  fov: number;
  far: number;
  near: number;
  zoom: number;
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export function savedCameraPositionNew(): SavedCameraPosition {
  return {
    isOrthograpic: false,
    position: new THREE.Vector3(),
    rotation: new THREE.Quaternion(),
    fov: 0,
    near: 0,
    far: 0,
    zoom: 1,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  };
}

export function savedCameraPositionFromCamera(camera: THREE.Camera, pos: SavedCameraPosition) {
  camera.getWorldPosition(pos.position);
  camera.getWorldQuaternion(pos.rotation);
  if (camera instanceof THREE.PerspectiveCamera) {
    pos.isOrthograpic = false;
    pos.zoom = camera.zoom;
    pos.far = camera.far;
    pos.near = camera.near;
    pos.fov = camera.fov;
  }
  if (camera instanceof THREE.OrthographicCamera) {
    pos.isOrthograpic = true;
    pos.zoom = camera.zoom;
    pos.far = camera.far;
    pos.near = camera.near;
    pos.left = camera.left;
    pos.right = camera.right;
    pos.top = camera.top;
    pos.bottom = camera.bottom;
  }
}

export function savedCameraPositionMatches(camera: THREE.Camera, pos: SavedCameraPosition) {
  const frameCameraPosition = new THREE.Vector3();
  const frameCameraRotation = new THREE.Quaternion();
  camera.getWorldPosition(frameCameraPosition);
  camera.getWorldQuaternion(frameCameraRotation);

  const positionDistance = frameCameraPosition.distanceTo(pos.position);
  const rotationDistance = frameCameraRotation.angleTo(pos.rotation);

  if (camera instanceof THREE.PerspectiveCamera) {
    if (pos.isOrthograpic) {
      return false;
    }
    const zoomDistance = Math.abs(camera.zoom - pos.zoom);
    const farDiff = Math.abs(camera.far - pos.far);
    const nearDiff = Math.abs(camera.near - pos.near);
    const fovDiff = Math.abs(camera.fov - pos.fov);
    if (
      positionDistance > 0.0001 ||
      rotationDistance > 0.0001 ||
      zoomDistance > 0.0001 ||
      farDiff > 0.01 ||
      nearDiff > 0.001 ||
      fovDiff > 0.01
    ) {
      return false;
    }
  } else if (camera instanceof THREE.OrthographicCamera) {
    if (!pos.isOrthograpic) {
      return false;
    }
    const zoomDistance = Math.abs(camera.zoom - pos.zoom);
    const farDiff = Math.abs(camera.far - pos.far);
    const nearDiff = Math.abs(camera.near - pos.near);
    const leftDiff = Math.abs(camera.left - pos.left);
    const rightDiff = Math.abs(camera.right - pos.right);
    const topDiff = Math.abs(camera.top - pos.top);
    const bottomDiff = Math.abs(camera.bottom - pos.bottom);
    if (
      positionDistance > 0.0001 ||
      rotationDistance > 0.0001 ||
      zoomDistance > 0.0001 ||
      farDiff > 0.01 ||
      nearDiff > 0.001 ||
      leftDiff > 0.0001 ||
      rightDiff > 0.0001 ||
      topDiff > 0.0001 ||
      bottomDiff > 0.0001
    ) {
      return false;
    }
  }
  return true;
}
